// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightInline-cls1_7ru","cls2":"CiterightInline-cls2_9n3 CiterightInline-cls1_7ru"};